import { useContext } from 'react'
import AuthContext from '../app/contexts/JWTContext'

const useAuth = () => useContext(AuthContext)

export default useAuth
